module.exports = __webpack_public_path__ + "static/icons/demo-smartphone.1e5e6ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/demo-smartphone.svg
// module id = UQQ8
// module chunks = 1